import { EColor } from "../../constants/colors";
import { ScoresEveryDayBrandRangeValues } from "../../types/scores";

export enum ETrendChartState {
  Up = "UP",
  Down = "DOWN",
  Neutral = "NEUTRAL",
}

export type IChartProps = {
  data: IChartData[];
  rangeValues?: ScoresEveryDayBrandRangeValues;
  visibleSeries: VisibleSeries;
  onDotClick: (created_at: string) => void;
};

export interface IChartData {
  created_at: string;
  visibility: number | null;
  sentiment: number | null;
  ranking: number | null;
  visibilityRange?: [number, number];
  sentimentRange?: [number, number];
}

export interface INormalizedChartDate extends IChartData {
  date?: string;
  rankingBar?: number | null;
  color?: ETrendChartState;
  isAfterLastDate?: boolean;
  empty?: boolean;
  isLast?: boolean;
}

export const colorMap = {
  [ETrendChartState.Up]: EColor.Green,
  [ETrendChartState.Down]: EColor.Red,
  [ETrendChartState.Neutral]: EColor.Gray,
};

export type TTooltipCoords = {
  x: number;
  y: number;
};

export enum ChartSeriesKey {
  Ranking = 'Ranking',
  Visibility = 'Visibility',
  Sentiment = 'Sentiment',
}

export type VisibleSeries = {
  [ChartSeriesKey.Ranking]: boolean;
  [ChartSeriesKey.Visibility]: boolean;
  [ChartSeriesKey.Sentiment]: boolean;
};

export type TooltipState = {
  type: 'line' | 'bar';
  x: number;
  y: number;
  payload: INormalizedChartDate;
} | null;
